var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fz-12"},[_vm._v("起："+_vm._s(_vm.row.apply_start_time))]),_c('div',{staticClass:"fz-12"},[_vm._v("止："+_vm._s(_vm.row.apply_end_time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }